import { useMutation } from '@tanstack/react-query';

import { exportPartyToAnva } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExportPartyToAnva() {
  return useMutation({
    mutationFn: ({ partyId }: { partyId: string }) =>
      exportPartyToAnva(
        {
          params: {
            path: { party_id: partyId },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
